module.exports = __webpack_public_path__ + "img/thumb_08.a4abab49.jpg";